<script lang="ts">
  const { n = 1, size = "1em", width = size, height = size, color = "currentColor", viewBox = "0 0 24 24" }: { n?: number; size?: string; width?: string; height?: string; color?: string; viewBox?: string } = $props();
</script>

<svg {width} {height} {viewBox}>
  <text
    text-anchor='middle'
    x='50%'
    y='70%'
    font-size='12px'
    fill='currentColor'
  >{n}</text>
  <path
    d="M21 10.12H20L16.96 7.3C14.23 4.6 9.81 4.5 7.08 7.2C4.35 9.91 4.35 14.28 7.08 17C9.81 19.7 14.23 19.7 16.96 17C18.32 15.65 19 14.08 19 12.1H21C21 14.08 20.12 16.65 18.36 18.39C14.85 21.87 9.15 21.87 5.64 18.39C2.14 14.92 2.11 9.28 5.62 5.81C9.13 2.34 14.76 2.34 18.27 5.81L21 3V10.12Z"
    fill={color}
  />
</svg>